/* eslint-disable */
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Validation } from '../../shared/services/validation.service';
import { ApplicationActions } from '../../actions/application.actions';
import { NgRedux } from '@angular-redux/store';

@Component({
  selector: 'md-checkbox',
  template: require('./checkbox.component.html')
})

export class CheckboxComponent {
  @Input() options;
  @Input() showUp;
  @Input() isValid;
  @Output() valueCheckBoxChange = new EventEmitter();
  @Output() valueChange = new EventEmitter();
  @Output() valueChangeInsider = new EventEmitter();
  @Output() valueChangeSelect = new EventEmitter();

  constructor(validation: Validation, appActions: ApplicationActions, ngRedux: NgRedux) {
    this.validation = validation;
    this.appActions = appActions;
    this.show = false;
    this.ngRedux = ngRedux;
    this.init = false;
    this.isValid = true;

    this.validateSub = this.validation.validateInput.subscribe(event => this.triggerValidation());
  }

  ngOnInit() {
    if (this.options.attr.inputClass === undefined) {
      this.options.attr.inputClass = '';
    }
    this.inputClass = this.options.attr.inputClass;

    this.event = {
      target: {
        id: this.options.attr.id,
        checked: this.show
      },
      isValid: (this.options.require === true && this.show === true) || this.options.require !== true
    };
    // Have to make sure it's not set to undefined
    this.show = this.options.startShown ? true : false;

    if (this.options.inputPath) {
      const arrayPath = this.options.inputPath.split('.');

      arrayPath.unshift('applicationStore');
      this.arrayPath = arrayPath;

      if (this.options.inputPath.match(/\[\d+\]/) !== -1) {
        this.reduxObservable$ = this.ngRedux.select(state => _.get(state, `applicationStore.${this.options.inputPath}`));
      } else {
        this.reduxObservable$ = this.ngRedux.select(this.arrayPath);
      }

      this.reduxSubscription = this.reduxObservable$.subscribe(state => {
        const oldState = this.currentValue || false;
        this.currentValue = state;

        if (this.currentValue != null || this.init === true) {
          this.options.attr.checked = this.currentValue;

          // Show hide
          if (oldState != this.currentValue) this.checkShowHide();

          this.event.isValid = (this.options.require === true && this.event.target.checked === true) || this.options.require !== true;
          this.valueCheckBoxChange.emit(this.event);
        }

        if (this.init === false) {
          const defaultState = this.options.attr.checked || false;
          this.appActions.setData(this.options.inputPath, this.currentValue || defaultState);
        } else {
          this.triggerValidation();
        }
        this.init = true;
      });
    }
  }

  ngOnDestroy() {
    if (this.validateSub) {
      this.validateSub.unsubscribe();
    }

    if (this.options.inputPath) {
      this.reduxObservable$.unsubscribe();
      this.reduxSubscription.unsubscribe();
    }
  }

  triggerValidation() {
    const isValidObj = {
      state: (this.options.require === true && this.event.target.checked === true) || this.options.require !== true,
      msg: 'This is required.'
    };
    if (isValidObj !== undefined) {
      this.inputClass = this.inputClass.replace('error', '');
      this.isValid = isValidObj.state;
      if (!this.isValid) {
        this.options.msg = this.options.msg || {};
        this.options.msg.fail = isValidObj.msg;
        this.inputClass += ' error';
      }

      let isValid = this.isValid;
      if (this.showUp === false) {
        isValid = true;
      }
      this.validation.validCheck({
        id: this.options.attr.id,
        isValid: isValid
      });
    }
  }

  onChange(event) {
    this.event = event;
    this.triggerValidation();

    if(this.options.inputPath) {
      this.appActions.setData(this.options.inputPath, event.target.checked);
    } else {
      this.event.isValid = (this.options.require === true && this.event.target.checked === true) || this.options.require !== true;
      this.valueCheckBoxChange.emit(this.event);
    }
  }

  // Since this should ONLY be called when value changes, we can assume show matches our checkbox's state if we manage it correctly (for now)
  checkShowHide() {
    if (this.options.showHide === true) {
      this.show = !this.show;
      if (this.show === true) {
        this.options.groupClass = '';
      } else {
        this.options.groupClass = 'hide';
      }
    }
  }

  updateOptionValue(event) {
    this.valueChangeInsider.emit(event);
  }
  updateSelectOptionValue(event) {
    this.valueChangeSelect.emit(event);
  }
}
